import { DateTimePicker } from "@mui/x-date-pickers";
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';

export default function DateTimePickerControl({ value, onChange, error, label, disabled, helperText, className, required, size }) {     

    const onPickerOpen = () => {
        if (!value)
            onChange(new Date());
    }

    return (
        <DateTimePicker
            format="dd/MM/yy HH:mm"
            className={className}
            label={label}
            required={required}
            disabled={disabled}
            helperText={helperText}
            error={error}
            value={value}
            onChange={onChange}
            ampm={false}
            inputVariant="outlined"
            onOpen={onPickerOpen}
            slotProps={{
                textField: {
                    size: size
                },
                popper: {
                    popperOptions: {
                        modifiers: [
                            {
                                name: 'flip',
                                options: {
                                    altBoundary: false,
                                    fallbackPlacements: ['right', 'left'],
                                },
                            },
                        ],
                    },
                }
            }}
            viewRenderers={{
                hours: renderTimeViewClock,
                minutes: renderTimeViewClock,
                seconds: renderTimeViewClock,
            }}
        />
    )
}